import { useEffect, useState } from "react";
import {
  CartesianGrid,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { api, type HrHrvResponse } from "../../lib/api";
import { EmptyState } from "../../components/EmptyState";

const ACCENT = "#9a3412";

export default function HeartHrv() {
  const [data, setData] = useState<HrHrvResponse | null | "error">(null);

  useEffect(() => {
    api.heart
      .hrv(90)
      .then(setData)
      .catch(() => setData("error"));
  }, []);

  const d = data && data !== "error" ? data : null;

  return (
    <div className="animate-fade-in">
      <h2 className="section-title mb-1">Heart rate variability</h2>
      <p className="text-ink-subtle text-small mb-4">
        HRV is the tiny variation between heartbeats — higher generally means a more recovered,
        less-stressed nervous system. It's one of the better day-to-day recovery signals.
      </p>

      {d && d.available ? (
        <div className="card card-pad">
          <ResponsiveContainer width="100%" height={260}>
            <LineChart data={d.series}>
              <CartesianGrid strokeDasharray="3 3" stroke="#e7e5e4" vertical={false} />
              <XAxis dataKey="date" axisLine={false} tickLine={false} fontSize={11} minTickGap={28} />
              <YAxis axisLine={false} tickLine={false} width={36} fontSize={11} domain={["auto", "auto"]} />
              <Tooltip formatter={(v: number) => [`${v} ms`, "HRV (RMSSD)"]} />
              <Line type="monotone" dataKey="hrv_ms" stroke={ACCENT} strokeWidth={2} dot={false} connectNulls />
            </LineChart>
          </ResponsiveContainer>
        </div>
      ) : (
        <EmptyState error={data === "error"} title="HRV isn't being collected yet">
          The bridge app currently reads steps, heart rate, sleep and workouts — not HRV. Samsung
          only exposes HRV to Health Connect on some watch models, and it needs an extra data type
          wired into the bridge. Ask Claude to “enable HRV collection” and it'll add it (a quick
          bridge update + reinstall); your readings will then build this chart.
        </EmptyState>
      )}
    </div>
  );
}
